module.exports = __webpack_public_path__ + "a32867cdba391d240ec031813b4b6062.fbx";